function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _require = require('./constants'),
  BUG_ACTIONS = _require.BUG_ACTIONS,
  BUG_PRIORITIES = _require.BUG_PRIORITIES,
  BUG_SEVERITIES = _require.BUG_SEVERITIES,
  BUG_STATUSES = _require.BUG_STATUSES,
  DEFAULT_WEIGHT = _require.DEFAULT_WEIGHT,
  MAX_TITLE_LENGTH = _require.MAX_TITLE_LENGTH,
  MAX_WEIGHT = _require.MAX_WEIGHT,
  MIN_WEIGHT = _require.MIN_WEIGHT;
var BASE58_RE = /^[1-9A-HJ-NP-Za-km-z]+$/;
var TRANSACTION_SIGNATURE_RE = /^[0-9a-f]{128}$/i;
function isReference(value) {
  return typeof value === 'string' && TRANSACTION_SIGNATURE_RE.test(value);
}
function isPublicKey(app, value) {
  var _app$crypto;
  var optional = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (optional && (value === '' || value == null)) {
    return true;
  }
  if (typeof value !== 'string' || !value) {
    return false;
  }
  if (typeof (app === null || app === void 0 || (_app$crypto = app.crypto) === null || _app$crypto === void 0 ? void 0 : _app$crypto.isPublicKey) === 'function') {
    return app.crypto.isPublicKey(value);
  }
  return value.length >= 32 && value.length <= 128 && BASE58_RE.test(value);
}
function normalizeCreate() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var root = String(data.root_tx_sig || data.bug_id || '').trim();
  var source = String(data.source_tx_sig || root).trim();
  return {
    bug_id: root,
    root_tx_sig: root,
    source_tx_sig: source,
    title: String(data.title || '').trim(),
    status: String(data.status || 'open').toLowerCase(),
    severity: String(data.severity || 'medium').toLowerCase(),
    priority: String(data.priority || 'normal').toLowerCase(),
    weight: Number.isSafeInteger(Number(data.weight)) ? Number(data.weight) : DEFAULT_WEIGHT,
    reporter_publickey: String(data.reporter_publickey || '').trim(),
    assignee_publickey: String(data.assignee_publickey || data.assignee || '').trim(),
    note_tx_sig: String(data.note_tx_sig || '').trim(),
    previous_metadata_tx_sig: String(data.previous_metadata_tx_sig || '').trim()
  };
}
function normalizeUpdate() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = String(data.action || '').toLowerCase();
  var normalized = {
    bug_id: String(data.bug_id || data.root_tx_sig || '').trim(),
    action: action,
    previous_metadata_tx_sig: String(data.previous_metadata_tx_sig || '').trim()
  };
  if (action === 'set-title') normalized.title = String(data.title || '').trim();
  if (action === 'set-status') normalized.status = String(data.status || '').toLowerCase();
  if (action === 'set-severity') normalized.severity = String(data.severity || '').toLowerCase();
  if (action === 'set-priority') normalized.priority = String(data.priority || '').toLowerCase();
  if (action === 'set-weight') normalized.weight = Number(data.weight);
  if (action === 'set-assignee') {
    normalized.assignee_publickey = String(data.assignee_publickey || data.assignee || '').trim();
  }
  return normalized;
}
function validateBugsMessage(app, message) {
  if (!message || message.module !== 'Bugs') {
    return {
      valid: false,
      error: 'Invalid module identifier'
    };
  }
  if (!['create bug', 'update bug'].includes(message.request)) {
    return {
      valid: false,
      error: 'Unrecognised Bugs request'
    };
  }
  if (!message.data || _typeof(message.data) !== 'object' || Array.isArray(message.data)) {
    return {
      valid: false,
      error: 'Missing Bugs transaction data'
    };
  }
  if (message.request === 'create bug') {
    var _data = normalizeCreate(message.data);
    if (!isReference(_data.root_tx_sig) || !isReference(_data.source_tx_sig)) {
      return {
        valid: false,
        error: 'Invalid RedSquare transaction reference'
      };
    }
    if (!_data.title || _data.title.length > MAX_TITLE_LENGTH) {
      return {
        valid: false,
        error: "Title must be 1-".concat(MAX_TITLE_LENGTH, " characters")
      };
    }
    if (!BUG_STATUSES.includes(_data.status)) return {
      valid: false,
      error: 'Invalid status'
    };
    if (!BUG_SEVERITIES.includes(_data.severity)) return {
      valid: false,
      error: 'Invalid severity'
    };
    if (!BUG_PRIORITIES.includes(_data.priority)) return {
      valid: false,
      error: 'Invalid priority'
    };
    if (!Number.isSafeInteger(_data.weight) || _data.weight < MIN_WEIGHT || _data.weight > MAX_WEIGHT) {
      return {
        valid: false,
        error: 'Invalid weight'
      };
    }
    if (!isPublicKey(app, _data.reporter_publickey, true)) {
      return {
        valid: false,
        error: 'Invalid reporter public key'
      };
    }
    if (!isPublicKey(app, _data.assignee_publickey, true)) {
      return {
        valid: false,
        error: 'Invalid assignee public key'
      };
    }
    if (_data.note_tx_sig && !isReference(_data.note_tx_sig)) {
      return {
        valid: false,
        error: 'Invalid explanatory-note transaction reference'
      };
    }
    if (_data.previous_metadata_tx_sig && !isReference(_data.previous_metadata_tx_sig)) {
      return {
        valid: false,
        error: 'Invalid predecessor metadata transaction reference'
      };
    }
    return {
      valid: true,
      request: message.request,
      data: _data
    };
  }
  var data = normalizeUpdate(message.data);
  if (!isReference(data.bug_id)) return {
    valid: false,
    error: 'Invalid bug reference'
  };
  if (data.previous_metadata_tx_sig && !isReference(data.previous_metadata_tx_sig)) {
    return {
      valid: false,
      error: 'Invalid predecessor metadata transaction reference'
    };
  }
  if (!BUG_ACTIONS.includes(data.action)) return {
    valid: false,
    error: 'Unrecognised Bugs action'
  };
  if (data.action === 'set-title' && (!data.title || data.title.length > MAX_TITLE_LENGTH)) {
    return {
      valid: false,
      error: "Title must be 1-".concat(MAX_TITLE_LENGTH, " characters")
    };
  }
  if (data.action === 'set-status' && !BUG_STATUSES.includes(data.status)) {
    return {
      valid: false,
      error: 'Invalid status'
    };
  }
  if (data.action === 'set-severity' && !BUG_SEVERITIES.includes(data.severity)) {
    return {
      valid: false,
      error: 'Invalid severity'
    };
  }
  if (data.action === 'set-priority' && !BUG_PRIORITIES.includes(data.priority)) {
    return {
      valid: false,
      error: 'Invalid priority'
    };
  }
  if (data.action === 'set-weight' && (!Number.isSafeInteger(data.weight) || data.weight < MIN_WEIGHT || data.weight > MAX_WEIGHT)) {
    return {
      valid: false,
      error: 'Invalid weight'
    };
  }
  if (data.action === 'set-assignee' && !isPublicKey(app, data.assignee_publickey, true)) {
    return {
      valid: false,
      error: 'Invalid assignee public key'
    };
  }
  return {
    valid: true,
    request: message.request,
    data: data
  };
}
function containsBugHashtag(text) {
  return typeof text === 'string' && /(^|\s)#bug(?=$|[\s.,!?;:()[\]{}])/i.test(text);
}
function isRootTweetMessage(message) {
  if ((message === null || message === void 0 ? void 0 : message.module) !== 'RedSquare' || (message === null || message === void 0 ? void 0 : message.request) !== 'create tweet') return false;
  var data = message.data || {};
  return !data.parent_id && !data.parent_tweet;
}
module.exports = {
  containsBugHashtag: containsBugHashtag,
  isReference: isReference,
  isRootTweetMessage: isRootTweetMessage,
  normalizeCreate: normalizeCreate,
  normalizeUpdate: normalizeUpdate,
  validateBugsMessage: validateBugsMessage
};